import axios from 'axios';

/**
 * @param {number} formId
 * @param {FormData} data
 */
export default function postForm(formId, data) {
  axios
    .post(
      `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`,
      data
    )
    .then((value) => {
      console.log(value.data);

      if (value.data.status !== 'mail_sent') {
        return;
      }

      /** @type {NodeListOf<HTMLElement>} */
      const targets = document.querySelectorAll('.form-main, .form-thanks');

      targets.forEach((value) => value.classList.add('is-sent'));
    })
    .catch((reason) => console.log(reason));
}
